import { render, staticRenderFns } from "./BetaComplete.vue?vue&type=template&id=e7ba47de&"
import script from "./BetaComplete.vue?vue&type=script&lang=js&"
export * from "./BetaComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports